import Hero04 from "./Hero04";
import Kingsway04 from "./Kingsway04";
import Columbia04 from "./Columbia04";
import Lester04 from "./Lester04";
import Banner04 from "./Banner04";

function main() {
  return (
    <div>
      <Hero04 />
      <Kingsway04 />
      <Banner04 />
      <Columbia04 />
      <Lester04 />
    </div>
  );
}

export default main;
